import type { SVGProps } from "react";
import { cn } from "@/lib/utils";

const AWSCodePipeline = (props: SVGProps<SVGSVGElement>) => {
  const { className, ...rest } = props;
  return (
    <svg
      className={cn(className)}
      height="1em"
      preserveAspectRatio="xMidYMid"
      version="1.1"
      viewBox="0 0 256 256"
      width="1em"
      {...rest}
    >
      <title>AWS CodePipeline</title>
      <defs>
        <linearGradient id="linearGradient-aws-codepipeline" x1="0%" x2="100%" y1="100%" y2="0%">
          <stop offset="0%" stopColor="#2E27AD" />
          <stop offset="100%" stopColor="#527FFF" />
        </linearGradient>
      </defs>
      <g>
        <rect fill="url(#linearGradient-aws-codepipeline)" height="256" width="256" x="0" y="0" />
        <path
          d="M96,99.2 L112,99.2 L112,92.8 L96,92.8 L96,99.2 Z M117.3344,195.7312 L111.4144,193.3024 L135.7088,134.032 L141.6288,136.4608 L117.3344,195.7312 Z M145.8272,178.496 L163.4176,163.0656 L145.84,147.8304 L150.0352,142.992 L170.384,160.6336 C171.0816,161.2384 171.4848,162.1184 171.488038,163.0432 C171.4912,163.968 171.0944,164.848 170.3968,165.4592 L150.048,183.3088 L145.8272,178.496 Z M81.6286482,163.3536 C81.6224,162.4288 82.016,161.5488 82.7104,160.9376 L102.9888,143.0112 L107.2256,147.808 L89.6928,163.3056 L107.1296,178.336 L102.9472,183.184 L82.736,165.7568 C82.0384,165.1552 81.6352,164.2784 81.6286482,163.3536 L81.6286482,163.3536 Z M200.112,112 L59.088,112 C52.976,112 48,107.0272 48,100.9152 L48,99.2 L86.4,99.2 L86.4,92.8 L48,92.8 L48,59.0848 C48,52.9728 52.976,48 59.088,48 L200.112,48 C206.224,48 211.2,52.9728 211.2,59.0848 L211.2,92.8 L121.6,92.8 L121.6,99.2 L211.2,99.2 L211.2,100.9152 C211.2,107.0272 206.224,112 200.112,112 L200.112,112 Z M70.4,211.2 L185.6,211.2 L185.6,118.4 L70.4,118.4 L70.4,211.2 Z M200.112,41.6 L59.088,41.6 C49.4432,41.6 41.6,49.4432 41.6,59.0848 L41.6,100.9152 C41.6,110.5568 49.4432,118.4 59.088,118.4 L64,118.4 L64,214.4 C64,216.1664 65.4304,217.6 67.2,217.6 L188.8,217.6 C190.5696,217.6 192,216.1664 192,214.4 L192,118.4 L200.112,118.4 C209.7568,118.4 217.6,110.5568 217.6,100.9152 L217.6,59.0848 C217.6,49.4432 209.7568,41.6 200.112,41.6 L200.112,41.6 Z"
          fill="#FFFFFF"
        />
      </g>
    </svg>
  );
};
export default AWSCodePipeline;
